import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { IUploadInfo } from 'views/bulkUpload/UploadCatalog/content/uploadCatalogInfo';
import { fgDefault } from 'styles/styles.constants';
import './UploadInfo.scss';

const UploadInfo = ({ title, description, icon, fontSize }: IUploadInfo) => {
  return (
    <article className="uploadInfo">
      <BordOneToneIcon variant={icon} customWidth="32px" stroke={fgDefault} className="uploadInfoIcon" />
      <h2 className="uploadInfoTitle">{title}</h2>
      <div className="uploadInfoDescription" style={{ fontSize }}>
        {description}
      </div>
    </article>
  );
};

export default UploadInfo;
